import React from "react";
import { Badge } from "../../../components/ui/badge";
import { Button } from "../../../components/ui/button";
import { ArrowUpRight } from "lucide-react";
import { navigate } from "../../../lib/router";
import { Safari } from "../../../components/ui/safari";
import homeImage from "../../../assets/home.png";
import calendario from "../../../assets/calendario.png";
import { useLanguage } from "../../../contexts/LanguageContext";
import { landingLabels } from "../labels";

const LandingHero = () => {
  const { lang } = useLanguage();
  const t = landingLabels[lang].hero;

  return (
    <div className="relative w-full flex items-center justify-center overflow-hidden pt-16 pb-16">
      {/* Background calendar image, positioned behind content */}
      <img
        src={calendario}
        alt={t.calendarAlt}
        aria-hidden
        width={900}
        height={900}
        fetchPriority="high"
        className="pointer-events-none select-none absolute top-0 left-1/2 -translate-x-1/2 -translate-y-8 w-[900px] max-w-none opacity-20 z-0"
      />
      <div className="relative z-10 max-w-screen-xl w-full mx-auto grid grid-cols-1 place-items-center gap-16 px-6 py-12 lg:py-0 text-center">
        <div className="my-auto flex flex-col items-center justify-center">
          <Badge className="bg-gradient-to-br from-[#71B27B] via-[#71B27B] to-[#71B27B] text-white rounded-full border-none px-3 py-1 sm:px-4 sm:py-1.5 md:px-5 md:py-2 xl:px-6 xl:py-2 text-xs sm:text-sm md:text-base xl:text-lg">
            {t.badge}
          </Badge>
          <h1 className="mt-6 max-w-[17ch] text-[54px] md:text-5xl lg:text-[2.75rem] xl:text-7xl font-bold !leading-[1.2] tracking-tight sm:text-6xl">
            {t.title[0]} <br /> {t.title[1]}
          </h1>
          <div className="mt-12 flex items-center gap-4">
            <Button
              variant="primary"
              icon={<ArrowUpRight className="!h-5 !w-5" />}
              iconPosition="right"
              onClick={() => navigate("/cadastro")}
            >
              {t.cta}
            </Button>

          </div>
        </div>
        <Safari url="www.suaagenda.com.br">
          <img
            src={homeImage}
            alt={t.homeAlt}
            width={1230}
            height={732}
            className="w-full h-auto"
          />
        </Safari>
      </div>
    </div>
  );
};

export default LandingHero;
